export default __webpack_public_path__ + "static/79-18e011fe4f852d3e1353539d01d85b73.png";